import { dashboardBffApiClient } from '~/lib/apiClient/clients/dashboardBffApiClient';
import { Roles } from '~/lib/auth';
import { Tenant } from '~/utils/tenants';

export const getOrganization = async (organizationId: string, roles: Roles, tenantId?: Tenant) => {
  const apiClient = dashboardBffApiClient({ roles, tenantId });

  const response = await apiClient.get(`/organizations/${organizationId}`);

  return response.data;
};
